import {
  FILE_ATTACHED_ITEMS_MODAL_TABLE_CELL_NAME,
  FILE_TITLE_ORDERING_NAME,
} from '../File.constants'

export const QA_NAME_FILE_ATTACH_MODAL = 'FileAttachModal'

export const FILE_ATTACHED_ITEMS_PAGE_COUNT = 20

export const ATTACHED_FILES_COLUMNS_CONFIG = {
  [FILE_ATTACHED_ITEMS_MODAL_TABLE_CELL_NAME.created]: {
    index: 3,
    name: FILE_ATTACHED_ITEMS_MODAL_TABLE_CELL_NAME.created,
    ordering_field: 'created',
    title: 'Modal.AttachedFilesColumnUploadedKey',
    visible: true,
    width: 150,
  },
  [FILE_ATTACHED_ITEMS_MODAL_TABLE_CELL_NAME.filename]: {
    index: 0,
    name: FILE_ATTACHED_ITEMS_MODAL_TABLE_CELL_NAME.filename,
    ordering_field: FILE_TITLE_ORDERING_NAME,
    title: 'Modal.AttachedFilesColumnTitleKey',
    visible: true,
    width: 580,
  },
  [FILE_ATTACHED_ITEMS_MODAL_TABLE_CELL_NAME.size]: {
    index: 2,
    name: FILE_ATTACHED_ITEMS_MODAL_TABLE_CELL_NAME.size,
    ordering_field: 'size',
    title: 'Modal.AttachedFilesColumnSizeKey',
    visible: true,
    width: 150,
  },
  [FILE_ATTACHED_ITEMS_MODAL_TABLE_CELL_NAME.usersAccess]: {
    index: 1,
    name: FILE_ATTACHED_ITEMS_MODAL_TABLE_CELL_NAME.usersAccess,
    ordering_field: null,
    title: 'Modal.AttachedFilesColumnUsersAccessKey',
    visible: true,
    width: 150,
  },
}
